import React from "react";
import logo from "../images/maxiv.png";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
} from "@material-ui/core";
import { loginURL } from "../utilities/Config";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MenuIcon from "@material-ui/icons/Menu";
import "./Header.css";
import { useStore } from "../store/Store";
import { Link } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import Drawer from "@material-ui/core/Drawer/Drawer";
import { Divider } from "@material-ui/core";

export const Header = (props: any) => {
  const { state } = useStore();
  const largeScreen = useMediaQuery("(min-width:960px)");
  const [drawerIsOpen, setDrawerIsOpen] = React.useState(false);
  const [publicationMenuOpen, setPublicationMenuOpen] = React.useState(false);
  const publicationMenuItems = [
    { text: "All Publications", path: "/" },
    { text: "Add Publications", path: "/publication/add" },
  ];

  let loginMessage = state.user.username ? (
    <>
      <Typography className="loginMessage header-username">
        {state.user.name}
      </Typography>
      <Button className="logoutBtn" onClick={props.onLogout}>
        LOGOUT
      </Button>
    </>
  ) : (
    <a href={loginURL + "?redirect=" + window.location.href}>
      <Button className="login-button">LOGIN</Button>
    </a>
  );

  const handleHamburgerToggle = () => {
    setDrawerIsOpen(!drawerIsOpen);
  };

  return (
    <div>
      {largeScreen ? (
        <>
          <div style={{ height: "4.3em" }}></div>
          <AppBar elevation={1} position="fixed">
            <Toolbar className="toolbar">
              <div
                style={{ display: "flex", alignItems: "center", width: "40%" }}
              >
                <IconButton
                  edge="start"
                  aria-label="menu"
                  href="http://www.maxiv.lu.se"
                >
                  <img className="maxLogo" src={logo} alt="Logo" />
                </IconButton>

                {state.user.isAdmin && (
                  <>
                    <div className="menuFlex">
                      <div
                        onMouseEnter={() => setPublicationMenuOpen(true)}
                        onMouseLeave={() => setPublicationMenuOpen(false)}
                      >
                        <div
                          className={
                            "header-menu-item header-dropdown-button " +
                            (publicationMenuOpen
                              ? "header-dropdown-button-active"
                              : "header-dropdown-button")
                          }
                        >
                          Publications
                          <ArrowDropDownIcon />
                        </div>
                        {publicationMenuOpen && (
                          <div className="header-dropdown-content">
                            {publicationMenuItems.map((item) => (
                              <Link
                                to={item.path}
                                key={item.text}
                                className="header-menu-subitem"
                                style={{ marginBottom: "0.2em" }}
                              >
                                {item.text}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                      <div className="">
                        <Link to="/manage-keywords" key={1}>
                          <div
                            className={
                              "header-menu-item header-dropdown-button " +
                              (publicationMenuOpen
                                ? "header-dropdown-button-active"
                                : "header-dropdown-button")
                            }
                          >
                            Keywords
                          </div>
                        </Link>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <Link to="/">
                <div className="header-app-name">
                  APXPS{" "}
                  <span className="header-app-name-secondary">
                    Publications
                  </span>
                </div>
              </Link>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "40%",
                }}
              >
                {loginMessage}
              </div>
            </Toolbar>
          </AppBar>
        </>
      ) : (
        <div>
          <div style={{ height: "4em" }}></div>
          <AppBar position="fixed" className="toolbar">
            <Toolbar className="mobileNavFlex">
              <IconButton edge="start" aria-label="menu" href="/">
                <img className="maxLogo" src={logo} alt="Logo" />
              </IconButton>
              <Link to={"/"}>
                <div className="header-app-name">APXPS</div>
              </Link>
              <IconButton
                className="link"
                aria-label="Menu"
                onClick={handleHamburgerToggle}
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Drawer
            onClick={handleHamburgerToggle}
            variant="persistent"
            open={drawerIsOpen}
          >
            {state.user.username ? (
              <>
                <div className="center-login">
                  <Typography className="loginMessage header-username-mobile">
                    {state.user.name}
                  </Typography>
                  <Button className="logoutBtn" onClick={props.onLogout}>
                    LOGOUT
                  </Button>
                </div>
              </>
            ) : (
              <div className="center-login">
                <a href={loginURL + "?redirect=" + window.location.href}>
                  <Button className="login-button">LOGIN</Button>
                </a>
              </div>
            )}

            <Divider style={{ backgroundColor: "#666" }} />

            <div className="drawer-menu-container">
              <span className="drawer-menu-category-mobile">Publications</span>
              {publicationMenuItems.map((item) => (
                <Link
                  to={item.path}
                  key={item.text}
                  className="link"
                  style={{ marginBottom: "0.2em" }}
                >
                  {item.text}
                </Link>
              ))}
              <span className="drawer-menu-category-mobile">Keywords</span>
              <Link to="/manage-keywords" key={1}>
                <div className="link">Manage Keywords</div>
              </Link>
            </div>
          </Drawer>
        </div>
      )}
    </div>
  );
};

export default Header;
